import React from "react";
import { Form, Modal, Button, Spin, Icon, Row, Col, Select } from 'antd';

import CatalogosRequest from '../../services/Catalogos';
import { openNotification } from '../../util/notificaciones';
import CentroDriveRequest from '../../services/CentroDrive';
import BaseComponent from "../Common/BaseComponent";

const { Option } = Select;
const { confirm } = Modal;

class FormAsignarCentro extends BaseComponent {
    state = {
        arrPlazas: [],
        arrDrives: [],
        arrCentro: [],
        guardando: false,
        bloquearBotones: false
    }

    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }

        if(this.props.modo === 'nuevo'){
            if(!state.arrPlazas.length){
                CatalogosRequest.ListarPlazas()
                    .then(plazaResp => {
                        state.arrPlazas = plazaResp.data;
                        return CatalogosRequest.ListarCentroSuministrador();
                    })
                    .then(centroResp => {
                        state.arrCentro = centroResp.data;
                        
                        this.setState(state);
                    })
                    .catch(err => {
                        this.setState({ cargando: false });
                        openNotification(
                            "Ha ocurrido un error.",
                            "Error",
                            false
                        )
                    });
            }
        }
        else {
            if(this.props.centroAsignado_selected !== prevProps.centroAsignado_selected)
            {
                if (this.props.centroAsignado_selected !== null) 
                {
                    if(!state.arrPlazas.length)
                    {
                        CatalogosRequest.ListarPlazas()
                        .then(plazaResp => {
                            state.arrPlazas = plazaResp.data;
                            return CatalogosRequest.ListarCentroSuministrador();
                        })
                        .then(centroResp => {
                            state.arrCentro = centroResp.data;
                            
                            return CatalogosRequest.ListarSitios(this.props.centroAsignado_selected.plaza_id);
                        })
                        .then(driveResp => {
                            state.arrDrives = driveResp.data;
                            
                            this.setState(state);
                        })
                        .catch(err => {
                            this.setState({ cargando: false });
                            openNotification(
                                "Ha ocurrido un error al listar las plazas.",
                                "Error al listar las plazas",
                                false
                            )
                        });
                    }
                }
            }
        }
        
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    onChangePlaza = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null
        if (value !== undefined) {
            state.plazaSelected = value
            CatalogosRequest.ListarSitios(value).then(response => {
                state.arrDrives = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar los drives de la plaza.",
                    "Error al cargar drives",
                    false
                )
            });
        }

        this.setState(state)
    }

    /**
        * Función que se manda a llamar cuando se cierra el modal.
    */
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.esconderModal(false);

        this.setState({ bloquearBotones: false, arrPlazas: [], arrDrives: [], arrCentro: [] })
    }

    /**
     * Comportamiento al confirmar la asignación del centro
     * @param: nada.
     * @return: nada.
     */
    showConfirm = (e) => {
       e.preventDefault();
       this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: <div><b>¿Está seguro de editar la asignación del centro?</b> Se cambiará la información actual de la asignación.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-asignacion-centro-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-asignacion-centro-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarAsignacionCentro())
                    },
                });
            }
        });
    }

    /**
     * Comportamiento al hacer clic en guardar la configuración de la asignación del centro suministrador
     * @param: nada.
     * @return: nada.
     */
    editarAsignacionCentro = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let state = { ...this.state }
                let id_centro = null;
                let objEnviar = {};
                objEnviar.sitio_id = [];

                objEnviar = {
                    centro: values.centro,
                    sitio_id: values.drive
                }

                if(this.props.centroAsignado_selected !== undefined){
                    if (this.props.centroAsignado_selected !== null) {
                        id_centro = this.props.centroAsignado_selected.id;
                    }
                }

                this.setState({ cargando: true }, () => {
                    CentroDriveRequest.editarCentroSuministrador(id_centro, objEnviar)
                        .then(response => {
                            state.cargando = false;
                            state.bloquearBotones = false;
                            
                            this.props.esconderModal(true);
                            this.props.form.resetFields();
                        })
                        .catch(err => {
                            this.setState({ cargando: false, bloquearBotones: false });
                            openNotification(
                                err?.response?.data?.cuerpo,
                                err?.response?.data?.titulo,
                                false
                            );
                        });
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        
        return(
            <div>
                <Modal
                    title= { this.props.modo === 'ver' ? 'ver detalle asignación' : this.props.modo === 'editar' ? 'Editar asignación' : 'Nueva asignación'}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={this.state.isPos ? "80%" : "70%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-asignarCentro"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo === 'ver' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-asignarCentro-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.guardando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                    >
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={8}>
                                    <Form.Item
                                        label={ this.props.modo !== "ver" ? "Plaza" : <b>Plaza</b> }
                                        colon={ this.props.modo === 'ver' ? false : true }
                                    >
                                        {
                                            getFieldDecorator(
                                                'plaza', {
                                                    rules: [
                                                    {
                                                        required: this.props.modo === 'ver' ? false : true,
                                                        message: 'Por favor, seleccione una plaza.'
                                                    },
                                                    ],
                                                    initialValue: (
                                                        ( this.props.centroAsignado_selected !== undefined && this.props.centroAsignado_selected !== null ) 
                                                        ? this.props.centroAsignado_selected.plaza_id
                                                        : []
                                                    )
                                                }
                                            )
                                            (
                                               <Select
                                                id="select-plaza-centro-asignacion"
                                                showSearch
                                                allowClear
                                                style={{ width: "100%" }}
                                                optionFilterProp="children"
                                                placeholder="Seleccionar..."
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                onChange={this.onChangePlaza}
                                                disabled={ this.props.modo === 'ver' ? true : false }
                                                showArrow={ this.props.modo === 'ver' ? false : true }
                                                className={ this.props.modo === 'ver' ? 'disableInput' : '' }
                                               >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                    {
                                                        this.state.arrPlazas.length > 0 &&
                                                        this.state.arrPlazas.map(obj => {
                                                            return (
                                                                <Option
                                                                    key={obj.id}
                                                                    value={obj.id}>
                                                                    {obj.nombre}
                                                                </Option>
                                                            )
                                                        })
                                                    }
                                               </Select> 
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Drive" : <b>Drive</b>}
                                        colon={this.props.modo === 'ver' ? false : true}
                                    >
                                        {
                                            getFieldDecorator('drive', {
                                                rules: [
                                                    {
                                                        required: this.props.modo === 'ver' ? false : true,
                                                        message: 'Por favor, seleccione un drive.'
                                                    },
                                                ],
                                                initialValue: (
                                                    ( this.props.centroAsignado_selected !== undefined && this.props.centroAsignado_selected !== null ) 
                                                    ? this.props.centroAsignado_selected.sitio
                                                    : []
                                                )
                                            })
                                            (
                                                <Select
                                                    id="select-drive-centro-asignacion"
                                                    showSearch
                                                    style={{ width: "100%" }}
                                                    defaultActiveFirstOption={false}
                                                    notFoundContent='No hay opciones'
                                                    placeholder="Seleccionar..."
                                                    optionFilterProp="children"
                                                    allowClear
                                                    showArrow={this.props.modo === 'ver' ? false : true}
                                                    disabled={this.props.modo === 'ver' ? true : false}
                                                    className={this.props.modo === 'ver' ? 'disableInput' : ''}
                                                    // mode="multiple"
                                                >
                                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                                    {
                                                        this.state.arrDrives.length > 0 &&
                                                        this.state.arrDrives.map(obj => {
                                                            return (
                                                                <Option
                                                                    key={obj.id}
                                                                    value={obj.id}>
                                                                    {obj.nombre}
                                                                </Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label={this.props.modo !== "ver" ? "Centro Suministrador" : <b>Centro Suministrador</b>}
                                        colon={this.props.modo === 'ver' ? false : true}
                                    >
                                        {
                                            getFieldDecorator('centro', {
                                                rules: [
                                                    {
                                                        required: true,
                                                        message: 'Por favor, seleccione el centro suministrador.'
                                                    },
                                                ],
                                                initialValue: (
                                                    ( this.props.centroAsignado_selected !== undefined && this.props.centroAsignado_selected !== null ) 
                                                    ? this.props.centroAsignado_selected.centro
                                                    : []
                                                )
                                            })
                                            (
                                                <Select
                                                    id="select-centro-asignacion"
                                                    showSearch
                                                    style={{ width: "100%" }}
                                                    defaultActiveFirstOption={false}
                                                    notFoundContent='No hay opciones'
                                                    placeholder="Seleccionar..."
                                                    optionFilterProp="children"
                                                    allowClear
                                                    showArrow={this.props.modo === 'ver' ? false : true}
                                                    disabled={this.props.modo === 'ver' ? true : false}
                                                    className={this.props.modo === 'ver' ? 'disableInput' : ''}
                                                >
                                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                                    {
                                                        this.state.arrCentro.length > 0 &&
                                                        this.state.arrCentro.map(obj => {
                                                            return (
                                                                <Option
                                                                    key={obj.id}
                                                                    value={obj.centro_upa}>
                                                                    {obj.almacen_upa}
                                                                </Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div>
        );
    }
}
export default Form.create()(FormAsignarCentro);